import type { Translations } from './types'

export const ro: Translations = {
  a11y: {
    openSupportChat: 'Deschide chatul de asistență',
    closeSupportChat: 'Închide chatul de asistență',
    supportUnread: (n: number) => (n === 1 ? '1 răspuns nou' : `${n} răspunsuri noi`),
    toggleTheme: 'Schimbă tema',
    openMenu: 'Deschide meniul',
    closeMenu: 'Închide meniul',
    courseVideos: 'Videoclipuri din curs',
    previousSlide: 'Anterior',
    nextSlide: 'Următor',
    goToSlide: (n: number) => `Mergi la slide-ul ${n}`,
  },
  support: {
    title: 'Discută cu noi',
    subtitle: 'Semnalează o problemă sau pune o întrebare',
    greeting: 'Salut! Cu ce te putem ajuta?',
    placeholder: 'Scrie un mesaj…',
    send: 'Trimite',
    emailPromptTitle: 'Vrei răspunsul și pe email?',
    emailPromptBody:
      'Încă nu a preluat nimeni conversația. Lasă-ne o adresă și îți răspundem și acolo, ca să nu trebuiască să aștepți aici.',
    emailPromptSubmit: 'Adaugă',
    emailPromptDismiss: 'Nu, mulțumesc',
    emailPromptDone: (email: string) => `Mulțumim — îți răspundem și la ${email}.`,
    emailLabel: 'Adresă de email',
    emailPlaceholder: 'tu@companie.com',
    privacyNote: 'O folosim doar ca să îți răspundem. Vezi',
    privacyLink: 'Politica de confidențialitate',
    pendingBadge: 'Netrimis încă',
    sending: 'Se trimite…',
    retry: 'Reîncearcă',
    validationEmail: 'Te rugăm să introduci adresa de email',
    validationEmailInvalid: 'Te rugăm să introduci o adresă de email validă',
    validationMessage: 'Te rugăm să scrii mai întâi un mesaj',
    errorGeneric: 'A apărut o problemă. Te rugăm să încerci din nou.',
    errorRateLimited: 'Prea multe mesaje. Te rugăm să încerci din nou peste puțin timp.',
    errorCaptcha: 'Te rugăm să completezi verificarea de securitate',
    errorSessionExpired: 'Această conversație a expirat.',
    threadClosed: 'Această conversație este închisă.',
    startNew: 'Începe o conversație nouă',
    endConversation: 'Încheie această conversație',
    endConfirm: 'Aceasta șterge conversația din acest browser. Continui?',
    emailedYou: (email: string) => `Îți trimitem răspunsul și pe email, la ${email}`,
    staffLabel: 'EVTIMIA',
    youLabel: 'Tu',
    imagesAfterFirstMessage: 'Scrie primul mesaj în text; după aceea poți adăuga imagini.',
  },
  chat: {
    moreActions: 'Acțiuni mesaj',
    reply: 'Răspunde',
    react: 'Reacționează',
    copyText: 'Copiază textul',
    copied: 'Copiat',
    edit: 'Editează',
    unsend: 'Anulează trimiterea',
    unsendConfirm: 'Ștergi acest mesaj pentru toată lumea?',
    pin: 'Fixează',
    unpin: 'Anulează fixarea',
    forward: 'Redirecționează',
    history: 'Istoric',
    edited: 'editat',
    removed: 'Acest mesaj a fost șters',
    replyingTo: (name: string) => `Răspunzi lui ${name}`,
    editing: 'Editezi mesajul',
    cancel: 'Anulează',
    pinnedCount: (n: number) => (n === 1 ? 'Mesaj fixat' : `${n} mesaje fixate`),
    forwarded: 'Redirecționat',
    forwardTitle: 'Redirecționează către…',
    forwardSearch: 'Caută conversații',
    forwardDone: (name: string) => `Redirecționat către ${name}`,
    forwardNone: 'Nicio conversație găsită.',
    historyTitle: 'Istoricul mesajului',
    historyEdited: 'Înainte de editare',
    historyUnsent: 'Șters',
    historyEmpty: 'Nu există versiuni anterioare.',
    reactedBy: (names: string) => `Reacții: ${names}`,
    mentionNone: 'Nimeni din conversație nu se potrivește',
    actionFailed: 'Nu a funcționat. Încearcă din nou.',
    you: 'Tu',
    notLoaded: 'Mesajul este prea vechi pentru a fi afișat.',
    fileRemoved: 'Fișier șters',
    image: 'Imagine',
    seen: 'Văzut',
    seenBy: (names: string) => `Văzut de ${names}`,
    typing: (name: string) => `${name} scrie…`,
    typingSeveral: 'Mai multe persoane scriu…',
    online: 'Online',
    lastSeen: (when: string) => `Văzut ultima dată ${when}`,
    teamOnline: 'Echipa este online',
    teamTyping: 'Echipa scrie…',
    searchNoResults: 'Niciun mesaj nu se potrivește.',
    closeSearch: 'Închide căutarea',
    emoji: 'Emoji',
    moreOptions: 'Mai multe opțiuni',
    moreReactions: 'Mai multe reacții',
    emojiSearch: 'Caută emoji',
    newMessage: 'Mesaj nou',
    newSupportMessage: 'Mesaj nou la suport',
    mentionedYou: 'Cineva te-a menționat',
    newFromTeam: 'Mesaj nou de la EVTIMIA',
  },
  chatHub: {
    searchEverything: 'Caută persoane, grupuri, mesaje și fișiere',
    searchInbox: 'Caută vizitatori, mesaje și fișiere',
    searchConversation: 'Caută în această conversație',
    sectionPeople: 'Persoane',
    sectionGroups: 'Grupuri',
    sectionMessages: 'Mesaje',
    sectionFiles: 'Fișiere',
    sectionVisitors: 'Vizitatori',
    noMatches: 'Nimic nu se potrivește.',
    typeMore: 'Continuă să scrii pentru a căuta mesaje și fișiere.',
    newChat: 'Nou',
    newGroup: 'Grup nou',
    groupName: 'Numele grupului',
    groupNamePlaceholder: 'de ex. Echipa de lansare',
    groupMembers: 'Membri',
    groupAddPeople: 'Adaugă colegi',
    groupCreate: 'Creează grupul',
    groupSave: 'Salvează',
    groupInfo: 'Detalii grup',
    groupLeave: 'Părăsește grupul',
    groupLeaveConfirm: 'Părăsești acest grup? Nu îi vei mai vedea mesajele.',
    groupMemberCount: (n: number) => (n === 1 ? '1 membru' : `${n} membri`),
    groupCreatedBy: (name: string) => `Creat de ${name}`,
    groupManagedBy: 'Doar persoana care a creat grupul sau un administrator îl poate redenumi sau îi poate schimba membrii.',
    groupRemoveMember: (name: string) => `Elimină pe ${name}`,
    groupNeedsName: 'Dă un nume grupului',
    groupNeedsMember: 'Adaugă cel puțin un coleg',
    groupFailed: 'Grupul nu a putut fi salvat. Te rugăm să încerci din nou.',
    groupYou: 'Tu',
    pushSection: 'Acest dispozitiv',
    pushSwitch: 'Notificări pe acest dispozitiv',
    pushNeedsInstall: 'Pe iPhone și iPad, notificările funcționează doar după ce adaugi EVTIMIA pe ecranul principal. În Safari, apasă Partajează, apoi „Adaugă pe ecranul principal”, deschide EVTIMIA din noua pictogramă și revino aici.',
    pushOnInHomeScreenApp: 'Notificările sunt deja pornite în aplicația EVTIMIA de pe ecranul principal. Deschide EVTIMIA din pictograma ei ca să le modifici.',
    pushBlocked: 'Notificările sunt blocate pentru acest site. Permite-le din setările browserului sau ale telefonului pentru acest site, apoi reîncarcă pagina.',
    pushUnsupported: 'Notificările nu pot fi activate în acest browser. Folosește o versiune actualizată de Chrome, Edge, Firefox sau Safari, ori alt browser care le acceptă.',
    pushInApp: 'Vezi această pagină în {app}, care nu poate afișa notificări. Deschide meniul aplicației (⋯ sau ⋮) și alege să deschizi pagina în browser, apoi activează-le acolo.',
    pushInAppUnknown: 'altă aplicație',
    pushDeclined: 'Browserul nu a permis notificările, așa că rămân dezactivate.',
    pushFailed: 'Notificările nu au putut fi activate. Te rugăm să încerci din nou.',
    nudgeTitle: 'Vrei să fii anunțat când primești răspuns?',
    nudgeBody: 'Activează notificările ca să afli de mesajele noi, chiar și când EVTIMIA este închis.',
    nudgeIos: 'Pe iPhone și iPad, notificările au nevoie de EVTIMIA pe ecranul principal: apasă Partajează, apoi „Adaugă pe ecranul principal”, și deschide EVTIMIA din noua pictogramă.',
    nudgeTurnOn: 'Activează notificările',
    nudgeDismiss: 'Închide',
    nudgeOn: 'Notificările sunt activate pe acest dispozitiv.',
    categories: {
      chat: { label: 'Mesaje directe și de grup' },
      mentions: { label: '@mențiuni', description: 'Când cineva te menționează, chiar dacă acel chat este dezactivat mai sus.' },
      clientMessages: { label: 'Conversații cu clienții' },
      workChats: { label: 'Chaturi de proiect și sarcină' },
      support: { label: 'Inbox suport', description: 'Vizitatori care scriu în chatul site-ului. După ce o conversație este atribuită, doar responsabilul ei este anunțat.' },
      taskReview: { label: 'Sarcini' },
      reminders: { label: 'Mementouri' },
      teamMessages: { label: 'Mesaje de la echipă' },
      deliveries: { label: 'Livrări noi' },
    },
    saveFailed: 'Modificarea nu a putut fi salvată. Te rugăm să încerci din nou.',
    newsletterTitle: 'Newsletter',
    newsletterLabel: 'Trimite-mi newsletterul EVTIMIA',
    newsletterDescription: 'Noutăți, ghiduri și oferte de la EVTIMIA. Te poți dezabona de aici oricând.',
    newsletterSince: (date: string) => `Abonat din ${date}.`,
    newsletterUnsubscribeTitle: 'Te dezabonezi de la newsletter?',
    newsletterUnsubscribeBody: 'Nu vei mai primi noutăți, ghiduri și oferte de la EVTIMIA. Te poți abona din nou oricând, de aici.',
    newsletterUnsubscribeConfirm: 'Dezabonează-mă',
    newsletterUnsubscribeCancel: 'Rămân abonat',
    mailingTitle: 'Listă de emailuri',
    mailingDescription: 'Descarcă o copie nouă înainte de fiecare trimitere, ca să fie excluși cei care s-au dezabonat.',
    mailingCount: (n: number) => (n === 1 ? '1 abonat' : `${n} abonați`),
    mailingDownload: 'Descarcă CSV',
    mailingEmpty: 'Nu s-a abonat nimeni încă.',
    mailingError: 'Lista de emailuri nu a putut fi încărcată.',
    mailingColumns: { name: 'Nume', email: 'Email', company: 'Companie', role: 'Rol', since: 'Abonat din' },
    mailingRoles: { admin: 'Administrator', employee: 'Angajat', client: 'Client' },
  },
  chatFiles: {
    attach: 'Atașează fotografii sau fișiere',
    recordVoice: 'Înregistrează un mesaj vocal',
    stopRecording: 'Oprește și adaugă',
    cancelRecording: 'Renunță la înregistrare',
    recording: 'Se înregistrează…',
    micDenied: 'Accesul la microfon a fost blocat. Permite-l în browser pentru a înregistra.',
    micUnsupported: 'Acest browser nu poate înregistra audio.',
    blocked: 'Acest tip de fișier nu poate fi trimis (programele și paginile web sunt blocate).',
    tooLarge: 'Prea mare: documente până la 50 MB, mesaje vocale 20 MB, videoclipuri 100 MB.',
    tooLargeSupport: 'Prea mare: fișierele din acest chat pot avea cel mult 25 MB.',
    tooLong: 'Mesajele vocale pot avea cel mult 5 minute.',
    tooMany: (max: number) => `Poți atașa cel mult ${max} fișiere la un mesaj.`,
    voiceNote: 'Mesaj vocal',
    video: 'Videoclip',
    file: 'Fișier',
    open: (name: string) => `Deschide ${name}`,
    download: 'Descarcă',
    remove: 'Elimină atașamentul',
  },
  chatImages: {
    attach: 'Adaugă imagini',
    remove: 'Elimină imaginea',
    dropHere: 'Plasează imaginile aici pentru a le adăuga',
    preparing: 'Se pregătește imaginea…',
    tooMany: (max: number) => `Poți adăuga cel mult ${max} imagini într-un mesaj.`,
    unsupported: 'Fișierul nu este o imagine pe care o putem trimite. Încearcă JPG, PNG, WebP sau GIF.',
    tooLarge: 'Imaginea este prea mare (peste 10 MB).',
    uploadFailed: 'Imaginile nu au putut fi încărcate. Nu s-a trimis nimic. Încearcă din nou.',
    open: (n: number, total: number) => (total > 1 ? `Deschide imaginea ${n} din ${total}` : 'Deschide imaginea'),
    alt: 'Imagine',
    copy: 'Copiază imaginea',
    copied: 'Copiată',
    copyFailed: 'Browserul a blocat copierea. Folosește Descarcă.',
    download: 'Descarcă',
    downloadFailed: 'Descărcarea a eșuat.',
    previous: 'Imaginea anterioară',
    next: 'Imaginea următoare',
    loadFailed: 'Imagine indisponibilă',
    viewerTitle: 'Vizualizare imagine',
    close: 'Închide',
  },
  nav: {
    home: 'Acasă',
    services: 'Servicii',
    work: 'Portofoliu',
    about: 'Despre',
    contact: 'Contact',
    login: 'Autentificare',
    signUp: 'Înregistrează-te',
    account: 'Cont',
    clientPortal: 'Portal client',
    crmDashboard: 'Panou CRM',
  },
  hero: {
    title: 'Noi facem munca digitală, ca tu să te ocupi de a ta.',
    subtitle: 'O agenție de marketing digital care combină creșterea strategică cu tehnologia responsabilă și inteligența artificială.',
    ctaBook: 'Programează o Consultanță',
    ctaServices: 'Explorează Serviciile',
  },
  closingCta: {
    eyebrow: 'Hai să vorbim',
    servicesLabel: 'Serviciile noastre',
    cardCta: 'Vezi serviciul',
    heading: 'Spune-ne cum te putem ajuta.',
    body: 'De obicei, o discuție scurtă e suficientă ca să ne dăm seama dacă ne potrivim. Fără prezentări, fără obligații.',
    primary: 'Programează o consultație',
    secondary: 'Trimite un mesaj',
  },
  whatIsEvtimia: {
    eyebrow: 'Ce este EVTIMIA?',
    statement: 'O echipă de marketing care pornește de la obiectivele afacerii tale.',
    intro: 'Planificăm, creăm și automatizăm prezența ta online în jurul a ceea ce vrei să obții — astfel încât fiecare postare, reclamă și pagină are un motiv să existe.',
    photoCaption: 'Studioul EVTIMIA, Cluj-Napoca',
    facts: [
      { title: 'Obiectivele întâi', body: 'Pornim de la obiectivele afacerii tale, apoi alegem canalele și conținutul care le servesc.' },
      { title: 'Strategie, conținut, consultanță', body: 'O singură echipă care stabilește direcția, face munca și rămâne alături de tine pe parcurs.' },
      { title: 'Marketing + tehnologie', body: 'Marketing digital, AI și automatizare împreună, construite să funcționeze mult după lansare.' },
    ],
    cta: 'Află mai multe despre noi',
    photoAlt: 'Microfoane, căști și o tabletă pe un birou de lemn în studioul EVTIMIA',
  },
  socialProof: {
    trustedBy: 'Au încredere în noi',
  },
  booking: {
    heading: 'Programează o Consultanță',
    subtitle: 'Programează un apel cu echipa noastră.',
    pickTime: 'Alege o oră',
    noSlots: 'Nu există ore disponibile în această zi.',
    selectedPrefix: 'Selectat',
    selectedNote: 'Completează datele de mai jos și îți trimitem invitația în calendar imediat.',
    timezoneNote: 'Orele sunt afișate în ora Bucureștiului (EET/EEST).',
    localTimeNote: 'Adică {time} la tine.',
    slotsError: 'Nu am putut încărca orele disponibile. Încearcă din nou în câteva momente.',
    nameLabel: 'Numele tău',
    namePlaceholder: 'Ana Popescu',
    emailLabel: 'Email',
    emailPlaceholder: 'ana@companie.ro',
    noteLabel: 'Despre ce ai vrea să discutăm? (opțional)',
    notePlaceholder: 'O frază-două ne ajută să ne pregătim.',
    submit: 'Rezervă această oră',
    submitting: 'Se rezervă…',
    missingHint: 'Mai lipsește: {fields}',
    securityCheck: 'verificarea de securitate',
    successTitle: 'Apelul tău este rezervat',
    successBody:
      'Verifică-ți emailul — ți-am trimis invitația în calendar cu linkul Google Meet pentru {when}.',
    slotTakenError: 'Ne pare rău, ora tocmai a fost ocupată. Te rugăm să alegi alta.',
    dailyLimitError: 'Rezervările sunt închise pentru azi. Te rugăm să încerci mâine sau să ne scrii la hello@evtimia.com.',
    genericError: 'Nu am putut finaliza rezervarea. Te rugăm să încerci din nou.',
  },
  footer: {
    description: 'O Întreprindere Socială care combină marketingul digital strategic cu tehnologia responsabilă și AI — dezvoltând afaceri și făcând educația digitală accesibilă.',
    companyDetails: 'EVTIMIA SRL',
    quickLinks: 'Linkuri Rapide',
    allRights: 'Toate drepturile rezervate.',
    privacyPolicy: 'Politica de Confidențialitate',
    terms: 'Termeni și Condiții',
    cookiePolicy: 'Politica de Cookie-uri',
    sal: 'SAL',
  },
  cookieBanner: {
    cookieSettings: 'Setări Cookie-uri',
    title: 'Respectăm confidențialitatea ta',
    description: 'Folosim cookie-uri pentru a ne asigura că site-ul funcționează corect. Cu acordul tău, putem folosi cookie-uri și pentru a înțelege cum interacționezi cu site-ul nostru și pentru a ne sprijini eforturile de marketing. Poți gestiona preferințele tale oricând.',
    acceptAll: 'Acceptă Toate',
    rejectNonEssential: 'Refuză Non-Esențiale',
    managePreferences: 'Gestionează Preferințele',
    strictlyNecessary: 'Strict Necesare',
    strictlyNecessaryDesc: 'Necesare pentru funcționalitatea de bază a site-ului, securitate și prevenirea fraudei. Aceste cookie-uri nu pot fi dezactivate.',
    analytics: 'Analiză și Performanță',
    analyticsDesc: 'Ne ajută să înțelegem cum interacționează vizitatorii cu site-ul prin colectarea de date anonimizate de utilizare.',
    marketing: 'Marketing și Comunicare',
    marketingDesc: 'Utilizate pentru a măsura eficiența campaniilor noastre și pentru a livra conținut relevant.',
    savePreferences: 'Salvează Preferințele',
    footerNote: 'Poți schimba sau retrage consimțământul tău oricând. Consultă',
    cookiePolicyLink: 'Politica de Cookie-uri',
    privacyPolicyLink: 'Politica de Confidențialitate',
    footerAnd: 'și',
    footerSuffix: 'pentru detalii.',
  },
  serviceCard: {
    popular: 'Popular',
    viewDetails: 'Vezi detalii',
  },
  serviceDetail: {
    addOns: 'Add-On-uri Disponibile',
    requestOffer: 'Solicită o Ofertă Personalizată',
    backToServices: 'Toate serviciile',
    otherServices: 'Alte Servicii',
    ctaHeading: 'Gata să începem?',
    ctaSubtitle: 'Spune-ne despre afacerea ta și construim împreună un plan potrivit.',
    pricingHeading: 'Abonament & Prețuri',
    pricingDescription: 'Un singur abonament lunar care acoperă strategia, producția și managementul.',
    planCta: 'Aplică pentru acest abonament',
    vettingNote: 'Nu se face nicio plată în avans. Completezi un formular scurt, echipa noastră analizează informațiile, iar abonamentul este facturat doar după ce acceptăm proiectul.',
    whatsIncluded: 'Ce include',
    servicesPricingHeading: 'Servicii & Prețuri',
    servicesPricingDescription: 'Alege serviciul de care ai nevoie — fiecare este ofertat și livrat separat.',
    mainServicesHeading: 'Proiecte Web Principale',
    maintenanceHeading: 'Mentenanță & Add-On-uri Recurente',
    itemCta: 'Solicită acest serviciu',
    serviceVettingNote: 'Nu se face nicio plată în avans. Completezi un formular scurt, echipa noastră analizează informațiile, iar serviciul este facturat doar după ce acceptăm proiectul.',
  },
  orderIntro: {
    orderOnline: 'Comandă online',
    included: 'Ce include',
    revisions: n => `${n} ${n === 1 ? 'rundă' : 'runde'} de revizuire`,
    delivery: n => `Livrare în aproximativ ${n} ${n === 1 ? 'zi lucrătoare' : 'zile lucrătoare'}`,
    rushDelivery: n => `${n} cu livrare urgentă`,
    price: 'Preț',
    priceFrom: price => `De la ${price} + TVA`,
    quoteOnly: days => `Fără preț de la început: primești o ofertă scrisă în ${days} ${days === 1 ? 'zi lucrătoare' : 'zile lucrătoare'}.`,
    prepare: 'Pregătește',
    needsQuote: 'Necesită ofertă',
    start: 'Începe',
    continueDraft: 'Continuă comanda',
    accountNote: 'Mai întâi îți faci un cont gratuit. Acolo urmărești comanda și primești fișierele.',
    close: 'Închide',
  },
  servicesPage: {
    tagline: 'Marketing Digital · AI · Automatizare',
    heroTitle: 'Sisteme de Marketing. AI. Automatizare. Impact Social.',
    heroSubtitle: 'Creștem afaceri prin marketing digital structurat, inteligență artificială și automatizare — cu un angajament față de impactul social și educația digitală.',
    ctaPlan: 'Obține un Plan Personalizat',
    gridTitle: 'Serviciile Noastre',
    gridSubtitle: 'Marketing digital end-to-end, structurat pentru claritate și rezultate măsurabile.',
    faqTitle: 'Întrebări Frecvente',
    faq: [
      {
        question: 'De ce să alegi EVTIMIA?',
        answer: 'EVTIMIA a fost construită pentru antreprenori care doresc o prezență online clară, eficientă și bine gândită. Lucrăm într-un mod structurat, pornind de la obiectivele de business și adaptând soluțiile la contextul fiecărei companii.',
      },
      {
        question: 'Cum susține EVTIMIA creșterea afacerilor?',
        answer: 'Combinăm marketing digital, tehnologie și automatizare pentru a livra soluții care funcționează pe termen lung și pot fi gestionate ușor de clienții noștri. Focusul nostru pe strategie, conținut și consultanță aplicată asigură că fiecare acțiune este legată de rezultate de business măsurabile — nu de metrici de vanitate.',
      },
      {
        question: 'Ce face EVTIMIA diferită de alte agenții?',
        answer: 'Nu ne limităm la livrarea de servicii de marketing. Credem că tehnologia are valoare reală doar când este înțeleasă, motiv pentru care investim constant în educație digitală și împărtășirea cunoștințelor. Oferim resurse gratuite și training dedicat pentru comunitate, cu scopul de a contribui la reducerea decalajului digital.',
      },
    ],
    ctaBook: 'Programează o Consultanță',
  },
  aboutPage: {
    heroTitle: 'Povestea Noastră',
    heroSubtitle1: 'EVTIMIA este o întreprindere socială în marketing digital care combină tehnologia modernă cu responsabilitatea față de comunitate.',
    teamTitle: 'Cunoaște Echipa',
    teamSubtitle: 'Nu suntem doar o agenție, suntem partenerii tăi în transformarea digitală.',
    missionTitle: 'Misiune',
    missionText: 'Ghidăm antreprenorii în utilizarea tehnologiei și inteligenței artificiale în mod inteligent și responsabil, pentru a-și crește afacerile și a lua decizii mai bine informate.',
    visionTitle: 'Viziune',
    visionText: 'Construim un spațiu în care marketingul, inteligența artificială și educația se completează reciproc în mod natural, astfel încât tehnologia să fie folosită conștient și responsabil, cu impact atât asupra dezvoltării afacerilor, cât și asupra vieții oamenilor și comunităților.',
    valuesTitle: 'Valorile Noastre',
    // The approach, the four pillars and the founder's words are the
    // brochure's slide 4 (EVTIMIA_BROSURA_PORTOFOLIU+SERVICII_25Feb_V1.pdf),
    // trimmed on 14 October 2026 so that no idea is said twice on the page;
    // the founder's words are hers, unchanged.
    values: [
      { title: 'Rezultate', text: 'Nu măsurăm succesul în like-uri, ci în vânzări și creștere.' },
      { title: 'Transparență', text: 'Raportări clare, comunicare deschisă, fără promisiuni nerealiste. Știi mereu unde sunt banii tăi și ce rezultate obții.' },
      { title: 'Impact social', text: 'Credem în tehnologie accesibilă. Educăm comunitatea locală prin resurse gratuite și training-uri și contribuim la reducerea decalajului digital.' },
      { title: 'Inovație', text: 'Folosim tehnologia modernă cu scop clar: eficiență, economie de timp și rezultate mai bune.' },
    ],
    studioTitle: 'Echipa Noastră. Studioul Nostru. Modul Nostru de Lucru.',
    heroEyebrow: 'Despre EVTIMIA',
    approachEyebrow: 'Abordarea noastră',
    approachTitle: 'Comunicare clară, rezultate măsurabile.',
    approachText:
      'Ne propunem să sprijinim clienții în construirea unei comunicări digitale clare și coerente, orientate spre rezultate măsurabile. Folosim inteligența artificială și automatizările pentru a aduce structură, eficiență și mai mult control asupra activităților de marketing, astfel încât afacerile să poată lua decizii informate și să se adapteze mai ușor într-un mediu digital în continuă schimbare.\n\nCeea ce ne diferențiază este faptul că nu ne limităm la livrarea de servicii de marketing: tehnologia are valoare reală atunci când este înțeleasă, nu doar delegată, motiv pentru care investim constant în educație digitală și în împărtășirea de cunoștințe.',
    missionVisionEyebrow: 'Ce ne ghidează',
    founderEyebrow: 'Fondatoarea noastră',
    founderQuote:
      'Am intrat în antreprenoriat în 2014, când am învățat marketing din nevoie, pentru a-mi susține prima afacere. Experiența mi-a arătat că un business sănătos nu poate crește fără un marketing bine gândit, capabil să susțină vânzările și rezultatele reale. Trecerea de la proiecte personale la colaborarea cu alți antreprenori mi-a oferit un avantaj important: înțelegerea directă a nevoilor de business, a constrângerilor și a presiunii deciziilor. Această perspectivă îmi permite să privesc marketingul dincolo de execuție, ca parte din strategia de dezvoltare a unei afaceri.\n\nMarketingul a devenit astfel o pasiune constantă, aplicată atât în propriile afaceri, cât și în colaborările cu partenerii. În toate proiectele, am urmărit o abordare personalizată, bazată pe colaborare și încredere. La EVTIMIA, lucrăm cu clienții dintr-o poziție de parteneriat, nu ca o agenție clasică, pentru că sunt convinsă că rezultatele apar atunci când marketingul este conectat real la business.',
    founderName: 'Ioana Sucală',
    founderRole: 'Fondator EVTIMIA',
    founderPhotoAlt: 'Ioana Sucală, fondatoarea EVTIMIA, la birou în studio',
  },
  workPage: {
    tagline: 'Studii de Caz · Proiecte · Impact Social',
    heroTitle: 'Munca din Spatele Rezultatelor.',
    heroSubtitle: 'De la propria noastră platformă de întreprindere socială până la brandurile pe care le creștem zi de zi — iată ce construim și pentru cine.',
    featuredLabel: 'Proiectul Nostru',
    visitSite: 'Vizitează site-ul',
    studioPhotoAlt: 'În studioul EVTIMIA',
    clientCardsHeading: 'Succesul lor, munca noastră',
    clientCardsSubheading: 'Atinge un card ca să vezi povestea lor.',
    screenshotsLabel: 'Proiecte selectate',
    galleryClose: 'Închide',
    clientVisitSite: 'Vizitează site-ul lor',
    clientFollowers: 'urmăritori',
    clientOpenProfile: 'Deschide profilul',
    clientSoundOn: 'Pornește sunetul',
    clientSoundOff: 'Oprește sunetul',
    clientServicesTitle: 'Serviciile din spatele rezultatelor',
    clientGalleryTitle: 'În culise',
    clientPostsTitle: 'Postări realizate de noi',
    clientPhotoOpen: 'Deschide fotografia {n} din {total}',
    clientPhotoClose: 'Închide fotografia',
    clientPhotoPrevious: 'Fotografia anterioară',
    clientPhotoNext: 'Fotografia următoare',
    galleryVisit: 'Vezi originalul',
    galleryOpenOn: 'Deschide pe',
    galleryPlatforms: { youtube: 'YouTube', tiktok: 'TikTok', instagram: 'Instagram', facebook: 'Facebook', linkedin: 'LinkedIn' },
    featuredBlurb: 'Platforma noastră de întreprindere socială: o bibliotecă gratuită de educație digitală, în română, pentru oamenii lăsați de obicei în urmă de tehnologie.',
    videosTitle: 'Vezi câteva dintre cursuri',
    videosSubtitle: 'Lecții scurte, fără jargon, din biblioteca Ghid.Online.',
    watchLabel: 'Vezi pe Ghid.Online',
    ghidCourses: 'Cursuri',
    ghidSeeAll: 'Vezi toate',
    ghidTracks: 'Direcții de învățare',
    ghidCourseOne: '1 curs',
    ghidCourseMany: '{n} cursuri',
    ghidPrevious: 'Cursul anterior',
    ghidNext: 'Cursul următor',
    ghidOfferTitle: 'Internetul, explicat în clipuri scurte.',
    ghidTopics: [
      { title: 'Siguranță online', hint: 'Fraude, linkuri false, 2FA' },
      { title: 'AI și tehnologie', hint: 'Deepfake, AI, social media' },
      { title: 'Competențe digitale', hint: 'Informații medicale, căutări corecte' },
    ],
    ghidAudience: 'În română · pentru orice vârstă',
    ghidPrice: '0 lei',
    ghidPriceNote: 'pe lună. Și pe an. Și pentru totdeauna.',
    ghidFreeQuips: [
      'Fără card. Fără probă. Fără capcane.',
      'Mai ieftin decât o cafea. Mult mai ieftin.',
      'Nimic nu e gratis pe internet. Cu o excepție.',
    ],
    videos: [
      { youtubeId: 'TXlDoqch8D0', title: 'Introducere în Biblioteca Digitală', category: 'Competențe digitale' },
      { youtubeId: '9VZwq6LXMpc', title: 'Importanța autentificării cu doi factori', category: 'Siguranță online' },
      { youtubeId: 'emfsIoDhLWU', title: 'Cum recunoști linkurile false de pe Facebook', category: 'Siguranță online' },
      { youtubeId: '4R64R1SWd1Q', title: 'Când relațiile de dragoste online devin înșelătorii', category: 'Siguranță online' },
      { youtubeId: '3oFQ3fVjcIw', title: 'Cum este folosită tehnologia deepfake în publicitate', category: 'Tehnologie' },
      { youtubeId: 'SgOjdUvz6Sc', title: 'AI și Social Media: cum ne influențează ce vedem online', category: 'Tehnologie' },
      { youtubeId: 'mwVEqwNxjjk', title: 'Trendul caricaturilor cu AI: distracție sau colectare de date?', category: 'Tehnologie' },
      { youtubeId: 'QfZeD4bZCfQ', title: 'Cum folosim internetul corect când luăm decizii medicale', category: 'Competențe digitale' },
    ],

    ctaHeading: 'Vrei rezultate similare?',
    ctaSubtitle: 'Spune-ne unde se află afacerea ta acum și unde vrei să ajungă.',
    ctaButton: 'Începe o Conversație',
  },
  loginPage: {
    signInTitle: 'Bine ai revenit',
    signInSubtitle: 'Autentifică-te pentru a accesa portalul tău EVTIMIA.',
    signUpTitle: 'Creează-ți contul',
    signUpSubtitle: 'Creează un cont pentru a-ți urmări proiectele și comenzile.',
    firstNameLabel: 'Prenume',
    firstNamePlaceholder: 'Prenumele tău',
    lastNameLabel: 'Nume',
    lastNamePlaceholder: 'Numele tău de familie',
    emailLabel: 'Email',
    emailPlaceholder: 'tu@companie.ro',
    passwordLabel: 'Parolă',
    passwordPlaceholder: 'Introdu parola',
    confirmPasswordLabel: 'Confirmă parola',
    confirmPasswordPlaceholder: 'Repetă parola',
    forgotPassword: 'Ai uitat parola?',
    signInButton: 'Autentifică-te',
    signUpButton: 'Creează cont',
    noAccount: 'Nu ai cont?',
    signUpLink: 'Înregistrează-te',
    haveAccount: 'Ai deja un cont?',
    signInLink: 'Autentifică-te',
    showPassword: 'Arată parola',
    hidePassword: 'Ascunde parola',
    comingSoonTitle: 'Portalul pentru clienți vine în curând',
    comingSoonMessage: 'Conturile nu sunt încă disponibile. Construim portalul în care îți vei urmări proiectele, comenzile și rapoartele într-un singur loc. Până atunci, scrie-ne și te ajutăm direct.',
    backToSite: 'Înapoi la site',
    validationFirstName: 'Te rugăm să introduci prenumele',
    validationLastName: 'Te rugăm să introduci numele de familie',
    validationEmail: 'Te rugăm să introduci emailul',
    validationEmailInvalid: 'Te rugăm să introduci o adresă de email validă',
    validationPassword: 'Te rugăm să introduci parola',
    validationPasswordShort: 'Parola trebuie să aibă cel puțin 8 caractere',
    validationPasswordRules: 'Parolei îi lipsește: {rules}',
    validationPasswordWeak: 'Această parolă este prea slabă sau ușor de ghicit. Te rugăm să alegi una mai puternică.',
    validationPasswordLeaked: 'Această parolă a apărut într-o breșă de securitate cunoscută. Te rugăm să alegi alta.',
    validationEmailTaken: 'Există deja un cont cu acest email. Autentifică-te sau resetează-ți parola.',
    validationEmailRejected: 'Această adresă de email a fost respinsă. Te rugăm să o verifici și să încerci din nou.',
    validationRateLimit: 'Prea multe încercări. Te rugăm să aștepți puțin și să încerci din nou.',
    validationConfirm: 'Te rugăm să confirmi parola',
    validationConfirmMismatch: 'Parolele nu coincid',
    pwRuleMinLength: 'Cel puțin 8 caractere',
    pwRuleUpper: 'O literă mare',
    pwRuleLower: 'O literă mică',
    pwRuleNumber: 'O cifră',
    pwRuleSymbol: 'Un simbol',
    pwRuleTooLong: 'Parola nu poate depăși 72 de caractere. Te rugăm să o scurtezi.',
    missingFields: 'Mai lipsește: {fields}',
    fieldFirstName: 'prenume',
    fieldLastName: 'nume',
    fieldEmail: 'email',
    fieldPassword: 'parolă',
    fieldConfirmPassword: 'confirmarea parolei',
    rememberEmail: 'Ține minte emailul meu',
    alreadyHaveAccount: 'Nu ai primit emailul? Este posibil să ai deja un cont.',
    emailTakenTitle: 'Acest email are deja un cont',
    emailTakenMessage: 'Autentifică-te cu contul existent sau resetează-ți parola dacă ai uitat-o.',
    goToSignIn: 'Autentifică-te',
    goToReset: 'Resetează-ți parola',
    signInError: 'Email sau parolă incorectă. Te rugăm să încerci din nou.',
    signUpError: 'Nu am putut crea contul tău. Te rugăm să încerci din nou.',
    resetTitle: 'Resetează-ți parola',
    resetSubtitle: 'Introdu emailul tău și îți vom trimite un link de resetare.',
    resetSent: 'Verifică-ți emailul',
    resetSentMessage: 'Dacă există un cont pentru acest email, ți-am trimis un link pentru resetarea parolei.',
    resetButton: 'Trimite link de resetare',
    resetError: 'Nu am putut trimite linkul de resetare. Te rugăm să încerci din nou peste puțin timp.',
    validationPasswordRejected: 'Această parolă nu îndeplinește cerințele. Te rugăm să alegi una mai lungă sau mai complexă.',
    backToSignIn: 'Înapoi la autentificare',
    checkEmailTitle: 'Confirmă-ți emailul',
    checkEmailMessage: 'Ți-am trimis un link de confirmare pe email. Accesează-l pentru a finaliza crearea contului.',
    onFileTitle: 'Te avem deja în evidență',
    onFileMessage:
      'Contul tău este deja creat la noi. Ți-am trimis pe email un link de activare: deschide-l ca să îți alegi parola și să vezi tot ce am pregătit pentru tine.',
    confirmLinkInvalidTitle: 'Linkul de confirmare a expirat sau este invalid',
    confirmLinkInvalidMessage: 'Acest link de confirmare a emailului nu mai este valid. Încearcă să te înregistrezi din nou pentru a primi unul nou.',
  },
  confirmEmailPage: {
    title: 'Confirmă adresa de email',
    subtitle: 'Apasă butonul de mai jos pentru a confirma adresa de email.',
    button: 'Confirmă',
    pendingTitle: 'Aproape gata',
    pendingMessage: 'Acum confirmă și folosind linkul trimis la cealaltă adresă de email.',
    invalidTitle: 'Acest link a expirat',
    invalidMessage: 'Linkul este mai vechi de 30 de minute sau a fost deja folosit. Cere unul nou și încearcă din nou.',
    home: 'Înapoi la pagina principală',
  },
  resetPasswordPage: {
    title: 'Alege o parolă nouă',
    subtitle: 'Introdu o parolă nouă pentru contul tău.',
    newPasswordLabel: 'Parolă nouă',
    newPasswordPlaceholder: 'Introdu noua parolă',
    confirmPasswordLabel: 'Confirmă parola nouă',
    confirmPasswordPlaceholder: 'Repetă noua parolă',
    submitButton: 'Actualizează parola',
    successTitle: 'Parolă actualizată',
    successMessage: 'Parola ta a fost schimbată. Te poți autentifica acum.',
    goToLogin: 'Mergi la autentificare',
    invalidLinkTitle: 'Link expirat sau invalid',
    invalidLinkMessage: 'Acest link de resetare a parolei nu mai este valid. Te rugăm să soliciți unul nou.',
    validationPasswordShort: 'Parola trebuie să aibă cel puțin 8 caractere',
    validationConfirmMismatch: 'Parolele nu coincid',
    pwRuleMinLength: 'Cel puțin 8 caractere',
    pwRuleUpper: 'O literă mare',
    pwRuleLower: 'O literă mică',
    pwRuleNumber: 'O cifră',
    pwRuleSymbol: 'Un simbol',
    pwRuleTooLong: 'Parola nu poate depăși 72 de caractere. Te rugăm să o scurtezi.',
    missingFields: 'Mai lipsește: {fields}',
    fieldPassword: 'parolă',
    fieldConfirmPassword: 'confirmarea parolei',
    genericError: 'Ceva nu a funcționat. Te rugăm să încerci din nou.',
  },
  setPasswordPage: {
    title: 'Setează parola',
    subtitle: 'Spune-ne numele tău și alege o parolă pentru a-ți activa contul.',
    firstNameLabel: 'Prenume',
    firstNamePlaceholder: 'Prenumele tău',
    lastNameLabel: 'Nume de familie',
    lastNamePlaceholder: 'Numele tău de familie',
    newPasswordLabel: 'Parola',
    newPasswordPlaceholder: 'Introdu parola',
    confirmPasswordLabel: 'Confirmă parola',
    confirmPasswordPlaceholder: 'Repetă parola',
    submitButton: 'Activează contul',
    successTitle: 'Cont activat',
    successMessage: 'Parola a fost setată. Te redirecționăm către spațiul de lucru…',
    invalidLinkTitle: 'Invitație expirată sau invalidă',
    invalidLinkMessage: 'Acest link de invitație nu mai este valid. Cere unui administrator să-l retrimită.',
    validationPasswordShort: 'Parola trebuie să aibă cel puțin 8 caractere',
    validationConfirmMismatch: 'Parolele nu coincid',
    pwRuleMinLength: 'Cel puțin 8 caractere',
    pwRuleUpper: 'O literă mare',
    pwRuleLower: 'O literă mică',
    pwRuleNumber: 'O cifră',
    pwRuleSymbol: 'Un simbol',
    pwRuleTooLong: 'Parola nu poate depăși 72 de caractere. Te rugăm să o scurtezi.',
    genericError: 'Ceva nu a funcționat. Te rugăm să încerci din nou.',
  },
  contactPage: {
    heroTitle: 'Hai să Vorbim',
    heroSubtitle: 'Spune-ne despre afacerea ta.',
    formTitle: 'Trimite-ne un mesaj',
    nameLabel: 'Nume',
    namePlaceholder: 'Numele tău',
    emailLabel: 'Email',
    emailPlaceholder: 'tu@companie.com',
    serviceLabel: 'Sunt interesat/ă de...',
    servicePlaceholder: 'Selectează un serviciu',
    optionalLabel: '(opțional)',
    messageLabel: 'Mesaj',
    messagePlaceholder: 'Spune-ne despre proiectul tău...',
    sendButton: 'Trimite Mesajul',
    sending: 'Se trimite...',
    successTitle: 'Mesaj Trimis',
    successMessage: 'Îți vom răspunde în curând.',
    errorMessage: 'Ceva nu a funcționat. Te rugăm să încerci din nou sau să ne scrii direct pe email.',
    dailyLimitMessage: 'Formularul este închis pentru azi. Te rugăm să încerci mâine sau să ne scrii la hello@evtimia.com.',
    validationEmail: 'Email-ul este obligatoriu.',
    validationEmailInvalid: 'Introdu un email valid.',
    validationMessage: 'Mesajul este obligatoriu.',
    serviceOptions: [
      'Abonament Social Media',
      'Automatizare & AI',
      'Web & Platforme Digitale',
      'Strategie & Identitate de Brand',
      'Social Media (A-La-Carte)',
      'PPC & Publicitate Plătită',
      'Altele / Cerere Personalizată',
    ],
  },
  notFound: {
    title: '404',
    message: 'Această pagină nu există.',
    backHome: 'Înapoi Acasă',
  },
  errorBoundary: {
    title: 'Această pagină a întâmpinat o problemă',
    message: 'Nu din vina ta. De obicei, reîncărcarea rezolvă situația.',
    retry: 'Reîncarcă pagina',
    backHome: 'Înapoi Acasă',
    contact: 'Spune-ne ce s-a întâmplat',
  },
  privacyPolicy: {
    title: 'Politica de Confidențialitate (GDPR)',
    lastUpdated: 'Ultima actualizare: 2 octombrie 2026',
    content: '',
  },
  termsPage: {
    title: 'Termeni și Condiții de Utilizare',
    lastUpdated: 'Ultima actualizare: 15 februarie 2026',
    content: '',
  },
  cookiePolicy: {
    title: 'Politica de Cookie-uri',
    lastUpdated: 'Ultima actualizare: 15 februarie 2026',
    content: '',
  },
  workData: {
    'ghid-online': {
      name: 'Ghid.Online',
      tagline: 'Învață digital, la orice vârstă',
      description:
        'Ghid.Online este platforma noastră de întreprindere socială — o bibliotecă gratuită de educație digitală construită pentru oamenii lăsați de obicei în urmă de tehnologie. Îi învață pe seniori, pe cei aflați în căutarea unui loc de muncă și pe oricine fără pregătire tehnică să folosească internetul în siguranță, să recunoască dezinformarea și să navigheze serviciile digitale de care depinde viața de zi cu zi. Totul este gratuit, în limba română și explicat de la zero.',
      highlights: [
        'Cursuri video gratuite pe trei direcții: competențe digitale generale, tehnologie și siguranță online',
        'Scrise și filmate pentru începători absoluți — fără jargon, fără cunoștințe presupuse',
        '„Stela", un asistent digital care recomandă cursul potrivit fiecărui vizitator',
        'Un chestionar scurt adaptează parcursul de învățare la vârstă, localitate și ocupație',
        'Construit pentru seniori, persoane în căutarea unui loc de muncă și comunități defavorizate digital',
        'Cofinanțat de Uniunea Europeană și Guvernul României prin programul „Start Întreprindere Socială în Mediul Urban"',
      ],
      stats: [
        { value: '12', label: 'Cursuri video' },
        { value: '3', label: 'Direcții de învățare' },
        { value: '100%', label: 'Acces gratuit' },
      ],
    },
    // TODO: înlocuiește descrierile placeholder de mai jos cu prezentările reale ale proiectelor.
    'imobiliare360': { name: 'Imobiliare360', description: '' },
    'credite360': { name: 'Credite360', description: '' },
    'asigurari360': { name: 'Asigurări360', description: '' },
    'nestor360': { name: 'Nestor360', description: '' },
    'eproprietar': { name: 'eProprietar', description: '' },
    'next-level-house': { name: 'Next Level House', description: '' },
    'exp': { name: 'eXp Realty', description: '' },
    'andreea-petcu': { name: 'Andreea Ștefania Petcu', description: '' },
    'doina-ielciu': { name: 'Doina Ielciu', description: '' },
    'sorin-sucala': { name: 'Sorin Sucală', description: '' },
  },
  serviceData: {
    'social-media-subscription': {
      title: 'Abonament Social Media',
      cardDescription: 'Un sistem complet de strategie, producție de conținut și management pentru o prezență online consistentă.',
      modal: {
        title: 'Sistem de Conținut Consistent',
        priceKey: 'smm.subscription',
        description: 'Un abonament complet creat pentru branduri care doresc o prezență social media consistentă și bine organizată.',
        tiers: [
          {
            name: 'Base',
            priceKey: 'smm.base',
            description: 'Prezență constantă pe cele două platforme cele mai importante pentru tine.',
            features: [
              '2 platforme principale',
              '~12 postări / lună',
              'Fără sesiune de filmare inclusă',
              'Community management standard',
              'Plan lunar de conținut',
              'Raport lunar de performanță',
            ],
          },
          {
            name: 'Pro',
            priceKey: 'smm.pro',
            description: 'Pachetul nostru publicat — acoperire completă pe platforme plus video lunar.',
            highlighted: true,
            badge: 'Cel mai popular',
            features: [
              '4 platforme principale',
              '20–22 postări / lună',
              '1 sesiune de filmare / lună (2–3 ore)',
              'Community management standard',
              'Plan lunar de conținut',
              'Monitorizare săptămânală a performanței',
            ],
          },
          {
            name: 'Premium',
            priceKey: 'smm.premium',
            description: 'Acoperire extinsă, producție suplimentară și coaching aplicat. Prețul final depinde de add-on-urile alese.',
            features: [
              '4 platforme + 1 extra',
              '20–22 postări / lună + mix extins',
              '1 sesiune de filmare / lună + sesiune suplimentară',
              'Community management extins',
              'Plan lunar de conținut',
              'Monitorizare săptămânală + coaching lunar',
            ],
          },
        ],
        sections: [
          {
            heading: 'Strategie & Planificare',
            items: [
              { label: 'Strategie social media personalizată' },
              { label: 'Activarea a 4 platforme principale (Facebook, Instagram, TikTok, LinkedIn)' },
              { label: 'Plan de conținut lunar actualizat pe baza obiectivelor și contextului' },
            ],
          },
          {
            heading: 'Conținut Consistent',
            items: [
              { label: 'Până la 5 postări / săptămână (20–22 postări / lună)' },
              { label: 'Mix lunar adaptat strategiei (ex. 2 postări statice + 3 video pe săptămână)' },
              { label: 'Cross-posting strategic și rotația conținutului între platforme' },
            ],
          },
          {
            heading: 'Producție Video (doar Cluj-Napoca)',
            items: [
              { label: '1 sesiune de filmare / lună (2–3 ore)' },
              { label: 'Editare pentru formate verticale (Reels / TikTok / Shorts)' },
              { label: 'Opțional: clonă digitală generată cu AI' },
            ],
          },
          {
            heading: 'Management & Suport',
            items: [
              { label: 'Publicare prin Metricool' },
              { label: 'Monitorizare săptămânală a performanței' },
              { label: '1 sesiune lunară de coaching pentru pregătirea filmărilor' },
            ],
          },
        ],
        addOns: [
          'Campanii Ads plătite',
          'Community management extins',
          'Sesiuni suplimentare de filmare',
          'Platforme suplimentare',
          'Videoclipuri suplimentare',
          'Clonă digitală',
        ],
      },
    },
    'automation-ai': {
      title: 'Automatizare & AI',
      cardDescription: 'Automatizare practică și orientată spre rezultate pentru a-ți eficientiza procesele și a economisi timp.',
      modal: {
        title: 'Servicii de Automatizare',
        description: 'Implementăm soluții pas cu pas, testăm fiecare flux de lucru și oferim training pentru a putea gestiona sistemele cu ușurință.',
        sections: [
          {
            heading: 'Servicii Disponibile',
            items: [
              {
                label: 'Integrare Management Social Media',
                priceKey: 'automation.social',
                details: [
                  'Conectează uneltele de postare, inbox și CRM',
                  'Programare automată și rutare a răspunsurilor',
                  'Configurare, testare și predare incluse',
                ],
              },
              {
                label: 'Automatizare Funnel Simplu',
                priceKey: 'automation.simple-funnel',
                details: [
                  'Leaduri sincronizate direct în CRM',
                  'Follow-up automat pe email și WhatsApp',
                  'Raportare de bază pe fiecare pas de conversie',
                ],
              },
              {
                label: 'Automatizare Funnel Complex',
                priceKey: 'automation.complex-funnel',
                details: [
                  'Fluxuri multi-canal cu logică condiționată',
                  'Scoring și segmentare de leaduri',
                  'Integrări între mai multe platforme',
                ],
              },
              {
                label: 'Agenți AI Personalizați',
                priceKey: 'automation.ai-agents',
                details: [
                  'Antrenați pe serviciile și tonul tău de voce',
                  'Preiau întrebări frecvente, calificare sau taskuri interne',
                  'Implementați pe canalul folosit cel mai des',
                ],
              },
              {
                label: 'Audit Procese & Arhitectură',
                priceKey: 'automation.audit',
                details: [
                  'Cartografierea fluxurilor actuale',
                  'Identificarea oportunităților de automatizare',
                  'Plan de implementare cu priorități',
                ],
              },
              {
                label: 'Training Automatizare',
                priceKey: 'automation.training',
                details: [
                  'Sesiuni practice cu echipa ta',
                  'Documentație pentru fiecare flux',
                  'Suport post-lansare pentru ajustări',
                ],
              },
            ],
          },
        ],
      },
    },
    'web-digital-platforms': {
      title: 'Web & Platforme Digitale',
      cardDescription: 'Dezvoltarea de site-uri web personalizate, magazine online și instrumente digitale interne.',
      modal: {
        title: 'Dezvoltare Web & Digitală (Low-Code/No-Code)',
        description: 'Soluții concepute pentru a se integra eficient în strategia ta de marketing și a susține creșterea pe termen lung.',
        sections: [
          {
            heading: 'Servicii Disponibile',
            items: [
              {
                label: 'Landing Pages & Web Design',
                priceKey: 'web.landing',
                details: [
                  'Design personalizat aliniat cu brandul tău',
                  'Construcție mobile-first, cu încărcare rapidă',
                  'Structură și CTA-uri orientate spre conversie',
                ],
              },
              {
                label: 'Site de Prezentare / Portofoliu',
                priceKey: 'web.portfolio',
                details: [
                  'Maxim 5 pagini și 8 proiecte',
                  'Formular de contact și SEO de bază',
                  'Comanzi online, fără apel',
                ],
              },
              {
                label: 'E-commerce — Magazine Online',
                priceKey: 'web.ecommerce',
                details: [
                  'Configurare catalog de produse și checkout',
                  'Integrări de plată și livrare',
                  'Training pentru gestionarea comenzilor',
                ],
              },
              {
                label: 'Instrumente Digitale Personalizate (CRM, dashboarduri)',
                priceKey: 'web.tools',
                details: [
                  'Dashboarduri interne și fluxuri CRM',
                  'Acces pe roluri pentru echipa ta',
                  'Construit pe procesele tale existente',
                ],
              },
              {
                label: 'Mentenanță & Optimizare Website (SEO/AEO)',
                priceKey: 'web.maintenance',
                details: [
                  'Actualizări, backup-uri și monitorizare',
                  'Îmbunătățiri SEO/AEO on-page',
                  'Raport lunar de performanță',
                ],
              },
              {
                label: 'Abonament Newsletter & Email Marketing',
                priceKey: 'web.newsletter',
                details: [
                  'Design de template și gestionarea listelor',
                  'Planificarea și trimiterea lunară a campaniilor',
                  'Urmărirea deschiderilor, clickurilor și conversiilor',
                ],
              },
            ],
          },
        ],
      },
    },
    'strategy-brand-identity': {
      title: 'Strategie & Identitate de Brand',
      cardDescription: 'Strategii fundamentale de marketing, management de proiect zilnic și identități vizuale coerente pentru afacerea ta.',
      modal: {
        title: 'Strategie & Identitate de Brand',
        sections: [
          {
            heading: 'Management de Proiect',
            priceKey: 'brand.pm',
            description: 'Asigurăm coordonarea zilnică a activităților de marketing, cu focus pe claritate, aliniere și rezultate măsurabile.',
            items: [
              { label: 'Ședințe regulate de lucru' },
              { label: 'Stabilirea obiectivelor' },
              { label: 'Monitorizarea KPI-urilor și bugetelor' },
              { label: 'Management de proiect pentru campaniile active' },
              { label: 'Raportarea rezultatelor' },
              { label: 'Coordonarea resurselor interne/externe' },
              { label: 'Implicare directă în optimizările în curs' },
            ],
          },
          {
            heading: 'Strategie de Marketing',
            priceKey: 'brand.strategy',
            description: 'Construim strategii de marketing adaptate fiecărei afaceri.',
            items: [
              { label: 'Analiză de piață și competitori' },
              { label: 'Public țintă & buyer personas' },
              { label: 'Poziționarea brandului & mesaje cheie' },
              { label: 'Selectarea canalelor de comunicare' },
              { label: 'Plan de acțiune detaliat pe 6–12 luni' },
              { label: 'Definirea KPI-urilor' },
              { label: 'Recomandări de buget' },
            ],
          },
          {
            heading: 'Logo Gata de Utilizare',
            priceKey: 'brand.logo',
            description: 'Un logo funcțional construit din șabloane profesionale.',
            items: [
              { label: 'Briefing' },
              { label: 'Selecția și adaptarea șablonului' },
              { label: 'Personalizare culori/tipografie' },
              { label: '1–2 runde de revizuire' },
              { label: 'Livrare în formate standard (PNG, JPG, PDF)' },
              { label: 'Versiuni monocrome' },
              { label: 'Ghid de utilizare de bază' },
            ],
          },
          {
            heading: 'Materiale Vizuale',
            description: 'Active de comunicare vizuală aliniate cu brandul tău.',
            items: [
              { label: 'Print: Cărți de vizită, flyere, broșuri, cataloage, ambalaje, roll-up-uri, bannere' },
              { label: 'Digital: Șabloane social media, prezentări, semnături email, bannere web, grafice newsletter' },
            ],
            priceKey: 'brand.visual',
          },
        ],
      },
    },
    'social-media-alacarte': {
      title: 'Social Media (A-La-Carte)',
      cardDescription: 'Management complet, creare de conținut și interacțiune cu comunitatea.',
      modal: {
        title: 'Servicii Social Media Individuale',
        sections: [
          {
            heading: 'Prețuri Servicii',
            items: [
              {
                label: 'Strategie Conținut Digital',
                priceKey: 'social.strategy',
                details: [
                  'Recomandări de canale și formate',
                  'Piloni de conținut și mesaje cheie',
                  'Cadru de calendar editorial',
                ],
              },
              {
                label: 'Copywriting & Redactare Conținut',
                priceKey: 'social.copywriting',
                details: [
                  'Descrieri, scripturi și texte de reclamă',
                  'Ton de voce consecvent al brandului',
                  'Include o rundă de revizuire',
                ],
              },
              {
                label: 'Postări Statice',
                priceKey: 'social.static',
                details: [
                  'Grafică branduită pentru fiecare postare',
                  'Descriere și set de hashtaguri',
                  'Dimensionat pentru fiecare platformă',
                ],
              },
              {
                label: 'Design Carusel',
                priceKey: 'social.carousel',
                details: [
                  'Maxim 7 slide-uri, la dimensiunea platformei',
                  'Fișier sursă editabil inclus',
                  'Comanzi online, fără apel',
                ],
              },
              {
                label: 'Conținut Video (Editare de Bază)',
                priceKey: 'social.video-basic',
                details: [
                  'Tăieturi, subtitrări și muzică',
                  'Export în format vertical',
                  'Livrat gata de publicare',
                ],
              },
              {
                label: 'Conținut Video (Editare Avansată)',
                priceKey: 'social.video-advanced',
                details: [
                  'Motion graphics și tranziții',
                  'Color grading și sound design',
                  'Versiuni în mai multe formate',
                ],
              },
              {
                label: 'Producție Conținut Video (Concept, filmare, editare)',
                priceKey: 'social.video-production',
                details: [
                  'Concept și listă de cadre',
                  'Filmare la locație',
                  'Editare completă și livrare',
                ],
              },
              {
                label: 'Conținut Comunitate (WhatsApp, Discord)',
                priceKey: 'social.community',
                details: [
                  'Moderare și răspunsuri zilnice',
                  'Subiecte de conversație și anunțuri',
                  'Sumar lunar de engagement',
                ],
              },
              {
                label: 'Coaching Conținut Video',
                priceKey: 'social.coaching',
                details: [
                  'Prezență și exprimare în fața camerei',
                  'Tehnici de scripting și hook',
                  'Setup de filmare cu propriul telefon',
                ],
              },
            ],
          },
        ],
      },
    },
    'ppc-advertising': {
      title: 'PPC & Publicitate Plătită',
      cardDescription: 'Transformă bugetul de publicitate în rezultate pe Meta, Google, TikTok și LinkedIn.',
      modal: {
        title: 'Campanii PPC',
        description: 'Strategie personalizată, configurare profesională, creative orientate spre performanță și optimizare zilnică. Buget minim recomandat pentru ads: 1.500–2.000 € / platformă.',
        sections: [
          {
            heading: 'Taxe de Management',
            items: [
              {
                label: 'Meta (Facebook & Instagram)',
                priceKey: 'ppc.meta',
                details: [
                  'Strategie de campanie și configurare audiențe',
                  'Creative adaptate pentru Feed, Reels și Stories',
                  'Optimizare zilnică și raportare lunară',
                ],
              },
              {
                label: 'Google Ads',
                priceKey: 'ppc.google',
                details: [
                  'Search, Performance Max și remarketing',
                  'Cercetare de cuvinte cheie și liste negative',
                  'Tracking de conversii și raportare lunară',
                ],
              },
              {
                label: 'TikTok Ads',
                priceKey: 'ppc.tiktok',
                details: [
                  'Creative native, adaptate trendurilor',
                  'Testarea și scalarea audiențelor',
                  'Optimizare zilnică și raportare lunară',
                ],
              },
              {
                label: 'LinkedIn Ads',
                priceKey: 'ppc.linkedin',
                details: [
                  'Targetare B2B pe rol și industrie',
                  'Formulare lead gen și mesaje sponsorizate',
                  'Raportare orientată pe pipeline',
                ],
              },
              {
                label: 'Platforme Alternative (Reddit, X, Spotify)',
                priceKey: 'ppc.alternative',
                details: [
                  'Configurare pe Reddit, X sau Spotify',
                  'Creative adaptate pentru fiecare platformă',
                  'Recomandări de buget de testare și raportare',
                ],
              },
            ],
          },
        ],
        notes: ['Bugetele de publicitate nu sunt incluse în taxele de management.'],
      },
    },
  },
}
